import { createStore } from 'vuex'

export default createStore({
    state: {
        count: 0,
        quiz: [],
        settings: {},
        languages: [],
    },
    mutations: {
        increment: state => state.count++,
        decrement: state => state.count--,
        setQuiz(state, quiz) {
            state.quiz = quiz
        },
        setSettings(state, settings) {
            state.settings = settings
        },
        setLanguages(state, languages) {

        }
    },
    actions: {},
    modules: {}
})